import { heroEquipment } from "../HeroEquipment";

export const nocneGobliny = {
  heroes: {
    "Herszt nocnych goblinów": {
      id: 0,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Nocne Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 7],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dowódca", "Dziwnie cuchnom", "Strachliwy", "Zasadzka", "Zawiść"],
      exp: 20,
      skills: [0, 1, 3, 4, 5],
    },
    "Szaman nocnych goblinów": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Nocne Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dziwnie cuchnom", "Mag (Magia Małego Łooomotu!)", "Zawiść"],
      exp: 12,
      skills: [0, 1, 4, 5],
    },
    "Sieciarz nocnych goblinów": {
      id: 2,
      startingEquipment: ["Sztylet", "Sieć"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Nocne Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dziwnie cuchnom", "Pułapkarz", "Ranger", "Zawiść", "Zwiadowca"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Nocne Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Dziwnie cuchnom", "Handlarz niewolników", "Zawiść", "Żertwa"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    "Nocny goblin": {
      id: 5,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 15,
      number: 15,
      equipmentList: heroEquipment["Nocne Gobliny"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Dziwnie cuchnom",
        "Rozmiar rzondzi",
        "Zawiść",
      ],
    },
    Snotling: {
      id: 6,
      startingEquipment: ["Broń improwizowana", "Wybuchowe zarodniki"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 2, 2, 1, 3, 1, 4],
        Maksymalna: [4, 2, 0, 2, 2, 1, 3, 1, 4],
      },
      rules: [
        "Mięso armatnie",
        "Nieświadomy",
        "Rozmiar rzondzi",
        "Sfora",
        "Śmigły",
        "Wybuchowe zarodniki",
      ],
    },
    "Gobliński fanatyk": {
      id: 7,
      startingEquipment: ["Kula na łańcuchu"],
      cost: 50,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", "-", "-", 5, 3, 1, 3, "K3", 10],
        Maksymalna: ["2K6", "-", "-", 5, 3, 1, 3, "K3", 10],
      },
      rules: ["Dziwnie cuchnom", "Gobliński fanatyk", "Zawiść"],
    },
    Squig: {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
        Maksymalna: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
      },
      rules: [
        "Dzikie squigi",
        "Niezłomny",
        "No to hooop!",
        "Rozmiar rzondzi",
        "Zwierzę",
      ],
    },
    "Nocny hop-goblin": {
      id: 9,
      startingEquipment: [
        "Sztylet",
        "Włócznia",
        "Tarcza",
        "Jaskiniowy squig",
        "Siodło & uprząż",
      ],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Nocne Gobliny"].Hop,
      type: "Stronnik",
      stats: {
        "Początkowa": [4,2,3,3,3,1,3,1,5],
        "Maksymalna": [5,5,6,3,4,3,6,4,7],
        "Jaskiniowy squig": ["3K6",4,0,5,"-","-",3,2,3]
      },
      rules: [
        "Animozja",
        "Dzikie squigi",
        "Dziwnie cuchnom",
        "Kawalerzysta",
        "Lekka jazda",
        "No to hooop!",
        "Rozmiar rzondzi",
        "Zawiść",
      ],
    },
    Troll: {
      id: 10,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {
        "Troll Górski": [50, 3, "Choice"],
        "Troll Rzeczny": [50, 3, "Choice"],
      },
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: ["Bycza szarża","Duży cel","Gatunki trolli","Głód trzewi","Głupota","Nieświadomy","Niezłomny","Przepastne trzewia","Regeneracja","Strach","Wielkolud","Żrąca plwocina"],
    },
    "Wielki squig": {
      id: 11,
      startingEquipment: ["Broń naturalna (zabójczy cios)"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["3K6", 4, 0, 5, 4, 3, 3, 3, 3],
        Maksymalna: ["3K6", 4, 0, 5, 4, 3, 3, 3, 3],
      },
      rules: [
        "Głód trzewi",
        "Niezłomny",
        "No to hooop!",
        "Potwór",
        "Wierzchowiec",
        "Zabójczy cios",
        "Zwierzę",
      ],
    },
    Rydwan: {
      id: 12,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Rydwan": ["-","-","-",5,5,8,"-","-","-"],
        "Jaskiniowy squig": ["3K6",4,0,5,"-","-",3,2,3],
        "Jaskiniowy squig ": ["3K6",4,0,5,"-","-",3,2,3]
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
    Więźniarka: {
      id: 13,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Jaskiniowy squig": ["3K6",4,0,5,"-","-",3,2,3],
        "Jaskiniowy squig ": ["3K6",4,0,5,"-","-",3,2,3]
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Nocne Gobliny",
  nature: "Zła",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: ["Czarny Ork", "Grzybowar", "Mekaniak"],
};
